import React, { useState, useEffect } from "react";
import {
  Typography,
  Card,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Box,
  Button,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import * as XLSX from "xlsx";

function Results({ data, theme, file }) {
  const [visibleRows, setVisibleRows] = useState(10);

  // Reset visible rows when data changes (e.g., new file uploaded)
  useEffect(() => {
    setVisibleRows(10);
  }, [data]);

  if (!data?.length > 0) {
    return null;
  }

  const handleDownload = () => {
    if (!data || data.length === 0) return;

    // Create a new worksheet from the data
    const worksheetData = data.map((row) => ({
      Targa: row.targa,
      Codice: row.codice,
      "Data Inizio Copertura": row.inizio,
      "Data Fine Copertura": row.fine,
      "Data Rendicontazione": row.rendicontazione,
      Collaboratore: row.collaboratore,
      Stato: row.message,
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Analisi");

    // Download the modified file
    XLSX.writeFile(workbook, `Analisi_${file?.name || "flotta.xlsx"}`);
  };

  const handleLoadMore = () => {
    setVisibleRows((prev) => prev + 10);
  };

  const displayedData = data.slice(0, visibleRows);
  const hasMore = visibleRows < data.length;
  const validRows = data.filter((row) => !row.error);

  return (
    <Card>
      <Box p={4}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="h6">
            Anteprima Dati ({validRows.length} valide su {data.length})
          </Typography>
          <Button onClick={handleDownload} variant="contained">
            Scarica file
          </Button>
        </Box>
        <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
          <Table stickyHeader aria-label="preview table" size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Riga</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Targa</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Codice</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>
                  Data Inizio Copertura
                </TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>
                  Data Fine Copertura
                </TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>
                  Data Rendicontazione
                </TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Collaboratore</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Stato</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {displayedData.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor: row.error
                      ? "rgba(255, 0, 0, 0.05)"
                      : "inherit",
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell>{row.row}</TableCell>
                  <TableCell>{row.targa}</TableCell>
                  <TableCell>{row.codice}</TableCell>
                  <TableCell>{row.inizio}</TableCell>
                  <TableCell>{row.fine}</TableCell>
                  <TableCell>{row.rendicontazione}</TableCell>
                  <TableCell>{row.collaboratore}</TableCell>
                  <TableCell
                    sx={{
                      color: row.error
                        ? theme.palette.error.main
                        : theme.palette.success.main,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {row.error ? (
                        <ErrorIcon fontSize="small" sx={{ mr: 1 }} />
                      ) : (
                        <CheckCircleIcon fontSize="small" sx={{ mr: 1 }} />
                      )}
                      <Typography variant="caption">{row.message}</Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {hasMore && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 2,
            }}
          >
            <Button
              variant="outlined"
              onClick={handleLoadMore}
              startIcon={<KeyboardArrowDownIcon />}
              fullWidth
            >
              Mostra altri 10 (Caricate {visibleRows} di {data.length})
            </Button>
          </Box>
        )}
      </Box>
    </Card>
  );
}

export default Results;
